import { useState } from "react";


import { FiSearch } from "react-icons/fi";
import AllPharmacyDetails from "../pharmacy/AllPharmacyDetails";
import StaffListTable from "./StaffListTable";
import StaffListGrid from "./StaffListGrid";


const StaffTabs = () => {
  const [activeTab, setActiveTab] = useState("ListView");

  // ✅ Mock Appointment Data
const staffData = [
  {
    id: 1,
    name: "Dr. Sarah Johnson",
    role: "Cardiologist",
    department: "Medical",
    contact: "sarah.j@clinic.com",
    phone: "555-0101",
    joined: "2012-05-15",
    status: "Active",
  },
  {
    id: 2,
    name: "Dr. Michael Chen",
    role: "Neurologist",
    department: "Medical",
    contact: "michael.c@clinic.com",
    phone: "555-0102",
    joined: "2015-06-22",
    status: "Active",
  },
  {
    id: 3,
    name: "Emma Rodriguez",
    role: "Head Nurse",
    department: "Nursing",
    contact: "emma.r@clinic.com",
    phone: "555-0103",
    joined: "2018-02-10",
    status: "On Leave",
  },
  {
    id: 4,
    name: "Robert Davis",
    role: "Lab Technician",
    department: "Laboratory",
    contact: "robert.d@clinic.com",
    phone: "555-0104",
    joined: "2019-11-05",
    status: "Active",
  },
  {
    id: 5,
    name: "Jennifer Kim",
    role: "Pharmacist",
    department: "Pharmacy",
    contact: "jennifer.k@clinic.com",
    phone: "555-0105",
    joined: "2017-03-18",
    status: "Active",
  },
  {
    id: 6,
    name: "David Wilson",
    role: "Radiologist",
    department: "Radiology",
    contact: "david.w@clinic.com",
    phone: "555-0106",
    joined: "2016-09-30",
    status: "Inactive",
  },
];



  const tabButtonStyle = (key) =>
    `inline-flex items-center justify-center whitespace-nowrap rounded-sm px-3 py-1.5 text-sm font-medium transition-all ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 ${
      activeTab === key
        ? "bg-white text-black shadow-sm"
        : "text-muted-foreground hover:text-black"
    }`;

  return (
    <div className="space-y-4">
      {/* Tabs */}
      <h4 className="h4 mt-2">Staff Directory</h4>
      <div className="flex items-center justify-between mb-4">
        <div className="bg-[#f5f5f5] inline-flex flex-wrap items-center rounded-md p-1 text-muted-foreground mt-1 flex-1">
          <button style={{flex:1}}
            onClick={() => setActiveTab("ListView")}
            className={tabButtonStyle("ListView")}
          >
            List View
          </button>
          <button style={{flex:1}}
            onClick={() => setActiveTab("GridView")}
            className={tabButtonStyle("GridView")}
          >
            Grid View
          </button>
        </div>
      </div>

      {/* Tab Content */}
      
        {activeTab === "ListView" && (
          <StaffListTable data={staffData} />
        )}
        {activeTab === "GridView" && (
          <StaffListGrid data={staffData}/>
        )}
     
      <div>
        
      </div>
    </div>
  );
};

export default StaffTabs;
